import React from 'react';

import { Box, Text, Tooltip } from '@mantine/core';
import { FloatingPosition } from '@mantine/core/lib/Floating';
import { useTranslation } from 'react-i18next';

interface TokenFactorBadgeProps {
  width: number;
  factor: number;
  infoTranslationKey: string;
  position: FloatingPosition;
  mutliline?: boolean;
  withinPortal?: boolean;
  disabled?: boolean;
}

export function TokenFactorBadge({
  width,
  position,
  factor,
  infoTranslationKey,
  mutliline = true,
  withinPortal = true
}: TokenFactorBadgeProps) {
  const { t } = useTranslation();

  return (
    <Tooltip
      position={position}
      multiline={mutliline}
      width={width}
      withArrow
      withinPortal={withinPortal}
      label={t(infoTranslationKey, { factor })}>
      <Box>
        <Text>{t('SMART_ASSISTANT.MODEL.X_FACTOR', { factor })}</Text>
      </Box>
    </Tooltip>
  );
}
